import { scaleOrdinal, ScaleOrdinal } from 'd3-scale';

import { colors } from './';
import { Quartile } from '../types/graphs';

const quartiles: Quartile[] = [0, 1, 2, 3];

type ColorStyles = (
  colorAttribute: string,
  selectorPrefix?: string,
  selectorSuffix?: string,
) => string;

/**
 * ColorStylesFactory
 * @param scale ScaleOrdinal coming from D3
 */
const ColorStylesFactory: (scale: any) => ColorStyles = scale => {
  return (attr, prefix = '', suffix = '') => {
    return quartiles
      .map(quartile => {
        return `${prefix}.quartile-${quartile} ${suffix} {
        ${attr}: ${scale(quartile)};
      };`;
      })
      .join();
  };
};

const quartileColors = [
  colors.red500,
  colors.orange500,
  colors.green100,
  colors.green500,
];

export const quartileColorScale = scaleOrdinal<Quartile, string>()
  .domain(quartiles)
  .range(quartileColors);

export const quartileColorStyles = ColorStylesFactory(quartileColorScale);
